<div class="row mt-5">
  <div class="col-12">
    <h3 id="propertyTransferredSharesClass">Contrepartie en actions</h3>

    <magieno-boolean-select
    [advancedFormControl]="isCalculateNumberOfPreferredShares"></magieno-boolean-select>

    @if (this.propertyForm.value.isCalculateNumberOfPreferredShares === true) {
      <div class="card">
        <div class="row card-body">
          <magieno-dynamic-select
            [advancedFormControl]="this.firstSharesClassId"
          [items]="this.getShareClassesSelectKeyValues()"></magieno-dynamic-select>
          @if (getShareClassForIdSelectedByIndex(0)?.value?.isRightToResidual === true) {
            <div class="alert alert-danger"
              role="alert">
              <i class="fas fa-exclamation-triangle"></i> Erreur: La catégorie d'actions ne peut être une
              catégorie d'actions ordinaires.
              Choisissez une catégorie d'actions privilégiées (non participantes)
            </div>
          }
        </div>
      </div>
    }

    @if (propertyForm.value.isCalculateNumberOfPreferredShares === false) {
      <div>
        @if (this.propertyTransferredSharesClasses.helpMessages.length != 0) {
          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert">
            <i class="fas fa-exclamation-triangle me-3"></i>
            <div>
              @for (helpMessage of this.propertyTransferredSharesClasses.helpMessages; track helpMessage) {
                <p>{{ helpMessage }}</p>
              }
            </div>
          </div>
        }
        <table class="table mt-5 mb-2">
          <thead class="table-light">
            <tr>
              <th>Catégorie d'actions</th>
              <th>Nombre d'actions</th>
              <th>Valeur de rachat des actions</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (propertyTransferredSharesClass of this.propertyTransferredSharesClasses.formGroups; track propertyTransferredSharesClass; let i = $index) {
              <tr>
                <td>
                  @if (shouldShowFairMarketValueWarning(i, propertyTransferredSharesClass)) {
                    <div class="alert alert-warning"
                      role="alert">
                      <i class="fas fa-exclamation-triangle"></i> Avertissement: Vérifier la juste valeur
                      marchande inscrite puisque cette valeur est différente
                      de la multiplication du nombre d'actions émis par la valeur de rachat par action
                    </div>
                  }
                  <magieno-dynamic-select
                    [advancedFormControl]="propertyTransferredSharesClass.formElements.sharesClassId"
                    [items]="getShareClassesSelectKeyValues()"
                  [showTitle]="false"></magieno-dynamic-select>
                </td>
                <td>
                  <magieno-input-number-field
                    [advancedFormControl]="propertyTransferredSharesClass.formElements.numberOfShares"
                  [showTitle]="false"></magieno-input-number-field>
                </td>
                <td>
                  <magieno-input-money-field [advancedFormControl]="propertyTransferredSharesClass.formElements.fairMarketValue"
                    [currency]="this.currency"
                    [locale]="this.locale"
                  [showTitle]="false"></magieno-input-money-field>
                </td>
                <td>
                  <div class="dropdown d-flex" style="width: fit-content">
                    <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                      data-expanded="false" href="#" role="button">
                      <i class="fe fe-more-vertical"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                      <a (click)="removePropertyTransferredSharesClass(i); $event.preventDefault()" class="dropdown-item"
                        href="#">
                        Supprimer
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <a (click)="this.addPropertyTransferredSharesClass();$event.preventDefault()"
          [id]="'property_transferred_' + propertyTransferredIndex + '_add_shares_class'" class="btn btn-primary ms-3"
          href="#propertyTransferredSharesClass">
          + Ajouter une contrepartie en actions
        </a>
      </div>
    }

  </div>
</div>
